import {connect} from 'react-redux';
import axios from 'axios';
import {Platform} from "react-native";

import SubmitRequestScreen22old from "../SubmitRequestScreen22";
import i18n from "../../../../../../I18n/i18n";
import {serviceActionListNotSendMyApply, serviceActionSetToken} from "../../../../splash/action/ActionSplashGetAllData";
import {
    callWebservice as callWebserviceListMyApply, serviceActionAddSubList
} from "../../action/ActionListMyApplysScreen";
import * as NavigationService from "../../../../../../redux/NavigationService";
import {AsyngStorageClass} from "../../../../../../tools/AsyngStorageClass";
import store from "../../../../../../redux/store/index";
import HMAlert from "../../../../../../customviews/HMAlert";
import {typeExport} from "../../../../../../redux/store/type";
import {Tools} from "../../../../../../tools/Tools";


const mapStateToProps = (state) => ({
    results: state.reducerSubmitRequestScreen22.results,
    isLoading: state.reducerSubmitRequestScreen22.isLoading,
    NoInternetDialog: state.reducerSubmitRequestScreen22.NoInternetDialog,

    resultsSet: state.reducerSubmitRequestScreen22.resultsSet,
    isLoadingSet: state.reducerSubmitRequestScreen22.isLoadingSet,
    NoInternetDialogSet: state.reducerSubmitRequestScreen22.NoInternetDialogSet,

    position: state.reducerSubmitRequestScreen22.position,
    id_category: state.reducerSubmitRequestScreen22.id_category,


    positionPersonnel: state.reducerSubmitRequestScreen22.positionPersonnel,
    id_Personnel: state.reducerSubmitRequestScreen22.id_Personnel,

    CartList: state.reducerSplashGetAllData.CartList,
    PriceAll: state.reducerSplashGetAllData.PriceAll,

    user: state.reducerSplashGetAllData.user,
    wallet: state.reducerSplashGetAllData.wallet,
    DataSplashScreen: state.reducerSplashGetAllData,
    // token: state.reducerSplash.token,

    FoodItem: state.reducerSplashGetAllData.FoodItem,
});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, token, item, index) => dispatch(callWebservice(getState, url, params, type, typeConnection, token, item, index)),

    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),

});

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, token, item, index) => {

    let {ListNotSendMyApply} = store.getState().reducerSplashGetAllData;
    switch (type) {
        case typeExport.TypeGetSubmitRequestScreen22:
            dispatch(serviceActionPending());

            break;

        case typeExport.TypeSetSubmitRequestScreen22:
            dispatch(serviceActionPendingSet());

            break;

        default:
    }

    let DateTime = new Date().getTime()

    let nameImage = DateTime + '.jpg';
    let nameVideo = DateTime + '.mp4';
    let nameAudio = DateTime + '.aac';

    const formData = new FormData();

    if(params.inspection){
        formData.append('_operation', typeExport._Contacts);
        // // formData.append('lang', params.lang);
        formData.append('mode', "SaveComplaint");
        formData.append('lang', params.lang);
        formData.append('token', params.token);
        formData.append('type', params.type);


        /*    formData.append('subject', params.subject);
            formData.append('description', params.description);
            formData.append('address', params.address);
            formData.append('longitude', params.longitude);
            formData.append('latitude', params.latitude);  */

        // formData.append('ticket_title', params.ticket_title);
        formData.append('topic', params.topic);
        formData.append('topiccate', params.topiccate);
        formData.append('topicId', params.topicId);
        formData.append('topiccateId', params.topiccateId);
        formData.append('description', params.description);
        formData.append('title', params.title);
        formData.append('address', params.address);
        formData.append('place', params.place);
        formData.append('person', params.person);
        formData.append('platform', Platform.OS);
    }
    else {
        formData.append('_operation', params._operation);
        formData.append('mode', "SaveTickets");
        formData.append('lang', params.lang);

        formData.append(params.typeComponent ? '_session' : 'token', params.token);
        formData.append('token_mahale', store.getState().reducerSplashGetAllData.tokenMahaleh);
        formData.append('type', params.type);
        formData.append('typepm', params.typepm);
        formData.append('subject', params.subject);
        formData.append('subjectid', params.subjectid);
        formData.append('description', params.description);
        formData.append('address', params.address);
        formData.append('longitude', params.longitude ? params.longitude : null);
        formData.append('latitude', params.latitude ? params.latitude : null);
        formData.append('private', params.private);
        formData.append('platform', Platform.OS);
    }


    // // if (params.audio && params.audio !== null) formData.append('audio', {
    // //     uri: params.audio,
    // //     name: nameAudio,
    // //     type: 'audio/aac'
    // // });
    //
    // if (params.audio && params.audio !== null) {
    //     formData.append('durationVoice', params.durationVoice);
    //
    //     if (Platform.OS === "web") {
    //         //  formData.append('audio', params.audio, nameAudio + ".aac");
    //         formData.append('audio', params.audioBlob, nameAudio);
    //         //const blobFile = new File([params.audio], nameAudio + ".aac");
    //         //formData.append("audio", params.audioBlob);
    //     }
    //     else
    //         formData.append('audio', {
    //             uri: params.audio,
    //             name: nameAudio,
    //             type: 'audio/aac'
    //         });
    // }
    //
    // // if (params.image && params.image !== null)
    // //     if (Platform.OS === "web") {
    // //         formData.append('image', params.image, nameImage );
    // //
    // //     }
    // //     else
    // //         formData.append('image', {
    // //             uri: params.image,
    // //             name: nameImage,
    // //             type: 'image/jpeg'
    // //         });
    // if (params.video && params.video !== null) {
    //     if (Platform.OS === "web") {
    //         //  formData.append('audio', params.audio, nameAudio + ".aac");
    //         formData.append('video', params.video, nameVideo);
    //         //const blobFile = new File([params.audio], nameAudio + ".aac");
    //         //formData.append("audio", params.audioBlob);
    //     }
    //     else
    //         formData.append('video', {
    //             uri: params.video,
    //             name: nameVideo,
    //             type: 'video/mp4'
    //         });
    // }
    // /*    if (params.video && params.video !== null) formData.append('video', {
    //         uri: params.video,
    //         name: nameVideo,
    //         type: 'video/mp4'
    //     });*/
    // for (let i = 0; i < params.arrImage.length; i++) {
    //
    //
    //     if (Platform.OS === "web") {
    //         formData.append('image' + "_" + i, params.arrImage[i], `${i}_${nameImage}`);
    //     }
    //     else
    //
    //         formData.append('image' + "_" + i, {
    //             uri: params.arrImage[i],
    //             name: nameImage,
    //             type: 'image/jpeg'
    //         });
    // }

    Tools.addAllFormData(formData, null,null,params);
    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            // 'Content-Type': 'application/json',
            "Authorization": `Basic ${params.token}`,
            timeout: params.video !== null ? typeExport._TIMEOUT_FILE : typeExport._TIMEOUT,
        }
    };
    /*    axios(
            {
                url: baseUrl + url + params,
                method: typeConnection,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                /!*      headers: {'X-Requested-With': 'XMLHttpRequest'},*!/
            }
        )*/
    axios.post(url, formData, config)
        .then(async response => {
            let data = response.data;
            //let obj=null;
            let obj = {
                address: params.address,
                code: "_",
                color: "#ff0000",
                comment: [],
                createdtime: params.date,
                image: params.image,
                video: params.video,
                audio: (params.audio && params.audio !== null) ? params.audio : null,
                platform: Platform.OS,
                /*    files: [
                        {
                            file: params.image,
                            type: "image/jpeg"
                        },
                        {
                            file: params.video,
                            type: "video/mp4"
                        },
                    ],*/
                latitude: params.latitude,
                longitude: params.longitude,
                status: i18n.t('constant.registrated'),
                title: params.subject,
                subjectid: params.subjectid
            };

            switch (type) {
                case typeExport.TypeGetSubmitRequestScreen22:

                    break;

                case typeExport.TypeSetSubmitRequestScreen22:
                    if (response.data.success === true) {
                        // dispatch(serviceActionSuccess(data, token, response.data.user));

                        dispatch(serviceActionSuccessSet(data));
                        HMAlert(
                            i18n.t('constant.message'),
                            response.data.message ? response.data.message : ((response.data.result?.message) ? response.data.result.message : i18n.t('constant.RequestSuccessfullyRegistered') + (item ? '\n' + i18n.t('constant.updateTheList') : '')),
                            [
                                {
                                    text: item ? i18n.t('constant.ok') : i18n.t('constant.ok'), onPress: () => {
                                        if (item) {

                                            let paramss = {
                                                "_operation": params._operation,

                                                "mode": typeExport.mode,
                                                "lang": i18n.locale,
                                                "token": store.getState().reducerSplashGetAllData.token,
                                                "page": 1,

                                                //"token_fb": this.props.DataSplashScreen.token_fb,
                                            };

                                            store.dispatch(callWebserviceListMyApply(null, typeExport.urlListMyApplyScreen, paramss, typeExport.TypeGetListMyApplyScreen, typeExport._POST, 1, 10, item.type))
                                            // this.props.callService(this.props.route.params.item.link_url, `&lang=${i18n.locale}&after=${after}&page=${page}`, typeExport.TypeGetListMyApplyScreen, _GET, page, typeExport._Count, this.props.route.params.item.id)
                                            //  this.props.callService(typeExport.urlListMyApplyScreen, `&lang=${i18n.locale}&after=${after}&page=${page}`, typeExport.TypeGetListMyApplyScreen, _GET, page, typeExport._Count, null)
                                            //   this.props.callService(typeExport.urlListMyApplyScreen, paramss, typeExport.TypeGetListMyApplyScreen, _POST, 1, 10, null)

                                        } else
                                            NavigationService.BackTo(1)
                                        //   NavigationService.navigatereset("ApplyScreen", {item: item ? item:getState.route.params.item})
                                    }


                                },
                                item ? {
                                    text: i18n.t('constant.NowNot'),
                                    onPress: () => {
                                    },
                                    style: 'cancel'
                                } : null,


                            ],
                            {cancelable: true}
                        )
                        if (item) {

                            ListNotSendMyApply.splice(index, 1);
                            await AsyngStorageClass.setAsyng(global.IdCity + typeExport.ListMyApplyOffline + item.type, ListNotSendMyApply);
                            store.dispatch(serviceActionListNotSendMyApply(ListNotSendMyApply));


                            // let arr = await AsyngStorageClass.getASyng(typeExport.ListMyApply + params.type)
                            // await AsyngStorageClass.setAsyng(typeExport.ListMyApply + params.type, [obj, ...arr])

                            let arr = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListMyApply + item.type)

                            await AsyngStorageClass.setAsyng(global.IdCity + typeExport.ListMyApply + item.type, [obj, ...arr])
                            store.dispatch(serviceActionAddSubList([obj, ...store.getState().reducerListMyApplyScreen.results]))

                        }


                        //   NavigationService.navigatereset('MainStack');
                    } else {
                        dispatch(serviceActionRefresh());
                        alert(response.data.error && response.data.error.message ? response.data.error.message : i18n.t('constant.ServerEncounteredProblemTryingAgain'))
                        //   NavigationService.navigatereset('LoginStack');
                    }
                    break;

                default:
            }
        }).catch((e) => {

        switch (type) {
            case typeExport.TypeGetSubmitRequestScreen22:
                dispatch(serviceActionError(e))

                break;

            case typeExport.TypeSetSubmitRequestScreen22:
                dispatch(serviceActionErrorSet(e))

                break;

            default:
        }
    })
}


// export const callSetStateCity =  (state_name,state_id,city_name,city_id)  => {

//     return dispatch (serviceActionSuccessSetCityStateData (state_name,state_id,city_name,city_id) )
// }
export const callWebservice = (getState, url, params, type, typeConnection, token, item, index) => {
    return dispatch => {
        //
        // // if (Platform.OS === 'ios') {
        // //     NetInfo.isConnected.addEventListener('connectionChange', (isConnected) => {
        // //             if (isConnected) {
        // //                 getDataDisatch(dispatch, getState ,url, params, type, typeConnection, token, item,index);
        // //             }
        // //             else {
        // //                 dispatch(serviceActionError("No Internet Connection"));
        // //             }
        // //         }
        // //     );
        // // }
        // // else {
        //     NetInfo.isConnected.fetch().then(isConnected => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState ,url, params, type, typeConnection, token, item,index);
        //         }
        //         else {
        //             switch (type) {
        //
        //                 case TypegetSubmitRequestScreen22:
        //                     dispatch(serviceActionError("no connect"));
        //                     break;
        //                 default:
        //             }
        //         }
        //     });
        // //}

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, token, item, index);
        //         } else {
        //             switch (type) {
        //
        //                 case typeExport.TypeGetSubmitRequestScreen22:
        //                     dispatch(serviceActionError("no connect"));
        //                     break;
        //                 default:
        //             }
        //         }
        //     }
        // )

        if (store.getState().reducerSplashGetAllData.Connection) {
            getDataDisatch(dispatch, getState, url, params, type, typeConnection, token, item, index);
        } else {
            switch (type) {
                case typeExport.TypeGetSubmitRequestScreen22:
                    dispatch(serviceActionError('error_Connection'))

                    break;

                case typeExport.TypeSetSubmitRequestScreen22:
                    dispatch(serviceActionErrorSet('error_Connection'))

                    break;

                default:
            }
        }

    }
}


export const serviceActionPending = () => ({
    type: typeExport.SubmitRequestScreen22_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    showDialohCity: false

})

export const serviceActionError = (error) => ({
    type: typeExport.SubmitRequestScreen22_SERVICE_ERROR,
    NoInternetDialog: true,
    error: error,
    isLoading: false,
    showDialohCity: false

})

export const serviceActionSuccess = (data) => ({
    type: typeExport.SubmitRequestScreen22_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    isLoading: false,
})

export const serviceActionPendingSet = () => ({
    type: typeExport.SubmitRequestScreen22_SERVICE_PENDING_Set,
    NoInternetDialogSet: false,
    isLoadingSet: true,

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.SubmitRequestScreen22_SERVICE_ERROR_Set,
    NoInternetDialogSet: true,
    error: error,
    isLoadingSet: false,

})

export const serviceActionSuccessSet = (data) => ({
    type: typeExport.SubmitRequestScreen22_SERVICE_SUCCESS_Set,
    NoInternetDialogSet: false,
    resultsSet: data,
    isLoadingSet: false,
})
export const serviceActionRefresh = () => ({
    type: typeExport.SubmitRequestScreen22_SERVICE_REFRESH,
    NoInternetDialog: false,
    results: null,
    isLoading: false,
})


export default connect(mapStateToProps, mapDispatchToProps)(SubmitRequestScreen22old);
